import { render, staticRenderFns } from "./ConfiguratorDataGrid.vue?vue&type=template&id=70fcdace&scoped=true&"
import script from "./ConfiguratorDataGrid.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorDataGrid.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguratorDataGrid.vue?vue&type=style&index=0&id=70fcdace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fcdace",
  null
  
)

export default component.exports